import { render } from "./QuizHeader.vue?vue&type=template&id=0f9641c9&scoped=true"
import script from "./QuizHeader.vue?vue&type=script&lang=js"
export * from "./QuizHeader.vue?vue&type=script&lang=js"

import "./QuizHeader.vue?vue&type=style&index=0&id=0f9641c9&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9641c9"]])

export default __exports__